var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_vm._t("aside-menu"),_vm._t("content")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }